export default "__VITE_ASSET__e_PVPhxS__"